<template>
  <div :class="['message-box', type]" v-if="isVisible">
    <!-- Icon Section -->
    <div class="icon-section">
      <IconProvider :name="iconName" />
    </div>

    <!-- Message Content -->
    <div class="message-content">
      <slot></slot>
    </div>

    <!-- Close Button -->
    <button
      v-if="showClose"
      class="close-button"
      @click="closeMessage"
    >
    &times;
    </button>
  </div>
</template>
<script>
import IconProvider from '../commons/IconProvider.vue';
export default {
  name: 'MessageBox',
  components: {
    IconProvider,
  },
  props: {
    type: {
      type: String,
      default: 'info', // Default type is 'info'
      validator: (value) => ['info', 'success', 'warning', 'error'].includes(value),
    },
    showClose: {
      type: Boolean,
      default: true, // Show the close button by default
    },
  },
  data() {
    return {
      isVisible: true, // Controls visibility of the message box
    };
  },
  computed: {
    iconName() {
      // Map message types to icons
      const icons = {
        info: 'Info',
        success: 'CheckCircle',
        warning: 'AlertTriangle',
        error: 'XCircle',
      };
      return icons[this.type];
    },
  },
  methods: {
    closeMessage() {
      this.isVisible = false; // Hide the message box
      this.$emit('close'); // Emit close event to parent
    },
  },
};
</script>
<style scoped>
.message-box {
  display: flex;
  align-items: center;
  background-color: #f0f8ff;
  padding: 6px;
  border-radius: 4px;
  margin-bottom: 16px;
  border: 1px solid rgb(191 219 254 / var(--tw-border-opacity, 1));
}

.message-box.info {
 margin-left: 8px;
 margin-right: 16px;
 font-size: 14px;
}

.icon-section{
  color:#007bff;
  margin: 6px 12px 0px 12px;
}

.message-box.success {
  background-color: #e6f7e9;
  color: #28a745;
}

.message-box.warning {
  background-color: #fff4e5;
  color: #ffc107;
}

.message-box.error {
  background-color: #fdecea;
  color: #dc3545;
}

.icon-section {
  margin-right: 12px;
}

.message-content {
  flex: 1;
}

.close-button {
  margin-right: 12px;
  font-size: 1.5rem;
  cursor: pointer;
  background: none!important;
  color: gray!important;
  padding: 0 !important;
}
</style>